export enum SubmodelElementTypes {
  Property = 'Property',
  MultiLanguageProperty = 'MultiLanguageProperty',
  SubmodelElementCollection = 'SubmodelElementCollection',
  SubmodelElementList = 'SubmodelElementList',
  File = 'File',
}
